<template>
  <div>
    <v-layout row v-show="locale === 'ja'">
      <v-flex :class="flexClass">
        <v-layout v-if="showLabel">
          <v-flex xs12 class="form-subtitle">
            フリガナ<span class="attention">（必須）</span>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12 md6>
            <v-text-field
              type="text"
              label="セイ*"
              v-model="last_name_kana"
              @input="updateKana"
              :error-messages="
                errorMessages && errorMessages.last_name_kana
                  ? errorMessages.last_name_kana
                  : ''
              "
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field
              type="text"
              label="メイ*"
              v-model="first_name_kana"
              @input="updateKana"
              :error-messages="
                errorMessages && errorMessages.first_name_kana
                  ? errorMessages.first_name_kana
                  : ''
              "
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <input type="hidden" name="last_name_kana" :value="hiddenLastNameKana">
    <input type="hidden" name="first_name_kana" :value="hiddenFirstNameKana">
  </div>
</template>

<script>
export default {
  props: {
    locale: {
      type: String,
      required: true,
      default: "ja",
    },
    lastName: {
      type: String,
    },
    firstName: {
      type: String,
    },
    initialLastNameKana: {
      type: String,
    },
    initialFirstNameKana: {
      type: String,
    },
    errorMessages: {
      type: Object,
      default: () => ({}),
    },
    variant: {
      type: String,
      default: "default",
      validator: (value) => ["default", "wide"].includes(value),
    },
  },
  computed: {
    flexClass() {
      return this.variant === "wide" ? "xs12 md12" : "xs12 md6";
    },
    showLabel() {
      return this.variant !== "wide";
    },
  },
  data() {
    return {
      last_name_kana: this.initialLastNameKana || "",
      first_name_kana: this.initialFirstNameKana || "",
      hiddenLastNameKana: this.initialLastNameKana || "",
      hiddenFirstNameKana: this.initialFirstNameKana || "",
    };
  },

  watch: {
    locale(newLocale) {
      if (newLocale === "en") {
        this.hiddenLastNameKana = this.lastName || this.last_name_kana || "";
        this.hiddenFirstNameKana = this.firstName || this.first_name_kana || "";
      }
    },
    lastName(newVal) {
      if (this.locale === "en") {
        this.hiddenLastNameKana = newVal || this.last_name_kana;
      }
    },
    firstName(newVal) {
      if (this.locale === "en") {
        this.hiddenFirstNameKana = newVal || this.first_name_kana;
      }
    },
  },
  mounted() {
    if (this.locale === "en") {
      this.hiddenLastNameKana = this.lastName || "";
      this.hiddenFirstNameKana = this.firstName || "";
    }
  },
  methods: {
    updateKana() {
      if (this.locale === 'en') {
        this.hiddenLastNameKana = this.lastName || this.last_name_kana || '';
        this.hiddenFirstNameKana = this.firstName || this.first_name_kana || '';
      } else {
        // `ja` or undefined のときは、入力欄の値をそのまま使う
        this.hiddenLastNameKana = this.last_name_kana;
        this.hiddenFirstNameKana = this.first_name_kana;
      }
      this.$emit('ready');
    }
  },
};
</script>

<style scoped>
.attention {
  color: #e3342f;
  font-size: 1rem;
}
</style>
